import React, { ReactNode } from "react";
import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps, ToggleButtonProps } from "@mui/material";

// ------------------ TOGGLE BUTTON GROUP ------------------

export type WcToggleButtonGroupProps = ToggleButtonGroupProps;

export const WcToggleButtonGroup = ({ ...props }: WcToggleButtonGroupProps) => (
  <ToggleButtonGroup {...props}>{props.children}</ToggleButtonGroup>
);

export default WcToggleButtonGroup;
// ------------------------------------------------------

// ------------------ TOGGLE BUTTON ------------------

export type WcToggleButtonProps = ToggleButtonProps & {
  children?: ReactNode;
};

export const WcToggleButton = ({ children, ...props }: WcToggleButtonProps) => <ToggleButton {...props}>{children}</ToggleButton>;
// ------------------------------------------------------
